import useWidth from '@components/Hooks/useWidth';
import { useWorkspacePadding } from '@components/v2/layout/hooks/useWorkspacePadding';
import { useEffect } from 'react';

interface UseObjectDetailsSlotParams {
  isOpen: boolean;
  onClose: () => void;
  isInlineOnTablet?: boolean;
}

export const useObjectDetailsSlot = ({
  isOpen,
  onClose,
  isInlineOnTablet,
}: UseObjectDetailsSlotParams) => {
  const { isCustomizedTablet, isCustomizedTabletDown } = useWidth();
  const { padding: workspacePadding } = useWorkspacePadding();

  const isFloating = isCustomizedTabletDown && (!isInlineOnTablet || !isCustomizedTablet);
  const hasBackdrop = isFloating;

  useEffect(() => {
    if (!hasBackdrop || !isOpen) {
      return;
    }

    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [hasBackdrop, isOpen, onClose]);

  return { isFloating, hasBackdrop, workspacePadding };
};
